var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLModal",
    _vm._g(
      _vm._b(
        {
          ref: "modal",
          staticClass: "terms-conditions",
          attrs: {
            size: "large",
            okBtnDisabled: !_vm.accepted && !_vm.acceptedByTxt,
            hasCancelBtn: !_vm.acceptedByTxt,
          },
        },
        "HKLModal",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c("div", { staticClass: "terms-conditions__title" }, [
        _c("p", [_vm._v(_vm._s(_vm.$t(_vm.i18nPrefix + ".title")))]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "terms-conditions__box" },
        _vm._l(_vm.$t(_vm.i18nPrefix + ".general"), function (section, index) {
          return _c(
            "div",
            { key: index, staticClass: "terms-conditions__content" },
            [
              _c("div", { staticClass: "terms-conditions__general" }, [
                _vm._v("\n        " + _vm._s(section.title) + "\n      "),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "terms-conditions__list" },
                _vm._l(section.content, function (item, j) {
                  return _c(
                    "div",
                    {
                      key: index + "_" + j,
                      staticClass: "terms-conditions__item",
                    },
                    [
                      _c("span", { staticClass: "terms-conditions__number" }, [
                        _vm._v(_vm._s(j + 1)),
                      ]),
                      _vm._v(" "),
                      _c("span", { domProps: { innerHTML: _vm._s(item) } }),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "terms-conditions__remarks" },
                _vm._l(section.additionalRemarks, function (remark, k) {
                  return _c("div", {
                    key: index + "__" + k,
                    domProps: { innerHTML: _vm._s(remark) },
                  })
                }),
                0
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "terms-conditions__acceptance" }, [
        _vm.acceptedByTxt
          ? _c("div", { staticClass: "terms-conditions__accepted" }, [
              _c("div", { domProps: { innerHTML: _vm._s(_vm.acceptContent) } }),
              _vm._v(" "),
              _c("div", { staticClass: "agreed-info" }, [
                _vm._v("\n        " + _vm._s(_vm.acceptedByTxt) + "\n      "),
              ]),
            ])
          : _c("div", { staticClass: "terms-conditions__checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.accepted,
                    expression: "accepted",
                  },
                ],
                attrs: { id: "tnc-checkbox", type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.accepted)
                    ? _vm._i(_vm.accepted, null) > -1
                    : _vm.accepted,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.accepted,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.accepted = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.accepted = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.accepted = $$c
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c("label", {
                staticClass: "terms-conditions__label",
                attrs: { for: "tnc-checkbox" },
                domProps: { innerHTML: _vm._s(_vm.onBehalfAcceptContent) },
              }),
            ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }